export const pxToRem = (px: number) => `${px / 16}rem` as const;

export const iconSize = {
  xs: pxToRem(12),
  sm: pxToRem(14),
  md: pxToRem(16),
  lg: pxToRem(20),
  xl: pxToRem(24),
  '2xl': pxToRem(30),
} as const;

export const menuMaxHeight = pxToRem(400);
